import { Injectable } from '@angular/core';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { FilterModel } from 'src/app/@core/models/filter.model';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';
import { CategoryContentsModel } from '../models/category-contents.model';

@Injectable({
  providedIn: 'root',
})
export class DigitalLibraryService extends BaseFucntionsService<CategoryContentsModel> {
  constructor(apiClient: ApiClientService) {
    super(ApplicationRoutes.TraineeCourse.Controller, apiClient);
  }

  getPaging(data: FilterModel, additionalQuery?: string): any {
    if (data?.sortField) {
      data.sortField =
        data.sortField.charAt(0).toUpperCase() + data.sortField.slice(1);
    }

    return this.apiClient.get(
      `${ApplicationRoutes.DigitalLibrary.GetCategoryContents}?${this.getQueryString(data) + additionalQuery}`
    );
  }
  
  getContentById(contentId: number) {
    return this.apiClient.get(`${ApplicationRoutes.DigitalLibrary.GetContent}?id=${contentId}`);
  }

  GetCategoriesDropDown() {
    return this.apiClient.get(`${ApplicationRoutes.DigitalLibrary.GetCategoryDropDown}`);
  }
}
